//dependencies
import $ from "jquery";

export default function() {

    function initCarousel() {

        $('.t1-slider').slick({
            autoplay: false,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon-arrow_slider_left"></i></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon-arrow_slider"></i></button>',
            fade: false,
            dots: false,
            focusOnSelect: true,
            mobileFirst: false,
            rows: 0,
            // responsive: [{
            //     breakpoint: 999999,
            //     settings: "unslick"
            // }, {
            //     breakpoint: 767,
            //     settings: {
            //         dots: true,
            //         swipe: true,
            //         slide: '.slide'
            //     }
            // }]
        });

        $('.three-col-slider').not('.slick-initialized').slick({
            autoplay: false,
            autoplaySpeed: 5000,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon-arrow_slider_left"></i></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon-arrow_slider"></i></button>',
            fade: false,
            dots: false,
            focusOnSelect: true,
            mobileFirst: false,
            rows: 0,
            responsive: [{
                breakpoint: 767,
                settings: {
                    swipe: true,
                    slidesToShow: 1
                }
            }]
        });

        $('.full-width-slider').not('.slick-initialized').slick({
            autoplay: false,
            autoplaySpeed: 5000,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon-arrow_slider_left"></i></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon-arrow_slider"></i></button>',
            fade: false,
            dots: false,
            focusOnSelect: true,
            mobileFirst: false,
            centerMode: true,
            rows: 0,
            responsive: [{
                breakpoint: 1850,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '30%'
                }
            },
            {
                breakpoint: 1350,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '20%'
                }
            },
            {
                breakpoint: 955,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '10%'
                }
            },
            {
                breakpoint: 767,
                settings: "unslick"
            }]
        });

        $('.disable-slider').not('.slick-initialized').slick({
            settings: "unslick"
        });

        console.log('init carousel');
    }
    
    // function reinitCarousel() {
    //     var $navTab = $('.in-page-tabs ul li a');
    //     console.log('tab clicked');
    //
    //     $navTab.on('click', function() {
    //         $('.three-col-slider').not('.slick-initialized').slick('resize');
    //     })
    // }

    // reinitCarousel();
    initCarousel();
}



// WEBPACK FOOTER //
// ./src/ui/js/apps/carousel.js